module.exports = __webpack_public_path__ + "img/Zurich.66302624.png";